var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 692,
    height: 692,
    viewBox: "0 0 692 692",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_527_72333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 692,
    height: 692,
    rx: 131,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.966 248.882C618.742 262.973 616.954 279.496 607.991 294.823L484.645 505.745C475.674 521.084 460.252 533.969 441.772 541.563L413.571 553.152C395.092 560.746 375.068 562.429 357.904 557.83L121.881 494.593C104.718 489.995 91.8211 479.493 86.0262 465.396L77.1795 443.877C71.3833 429.777 73.1673 413.237 82.139 397.896L205.484 186.985C214.455 171.646 229.877 158.762 248.357 151.168L276.567 139.575C295.047 131.981 315.071 130.298 332.235 134.897L568.258 198.14C585.404 202.734 598.293 213.221 604.095 227.297C604.101 227.312 604.107 227.326 604.113 227.341L612.952 248.849C612.956 248.86 612.961 248.871 612.966 248.882Z",
    stroke: "#0AA207",
    strokeWidth: 26
  }), /*#__PURE__*/React.createElement("line", {
    y1: -13,
    x2: 442.684,
    y2: -13,
    transform: "matrix(-0.504829 0.863219 -0.965926 -0.258819 570.893 185.859)",
    stroke: "#0AA207",
    strokeWidth: 26
  }), /*#__PURE__*/React.createElement("line", {
    y1: -13,
    x2: 442.684,
    y2: -13,
    transform: "matrix(-0.504829 0.863219 -0.965926 -0.258819 332.838 122.072)",
    stroke: "#0AA207",
    strokeWidth: 26
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_527_72333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 692,
    height: 692,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcone);
export default __webpack_public_path__ + "static/media/logo_icone.1df68f6f61ff7d507753ec038416860a.svg";
export { ForwardRef as ReactComponent };